import React from 'react';

import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import NavPrimaryGenericSubmenu from 'components/navV2/navPrimarySubMenu/subMenus/NavPrimaryGenericSubMenu';
import NavPrimaryRegistrySubmenu from 'components/navV2/navPrimarySubMenu/subMenus/NavPrimaryRegistrySubMenu';
import NavPrimaryLargeModuleSubMenu from 'components/navV2/navPrimarySubMenu/subMenus/NavPrimaryLargeModuleSubMenu';
import NavPrimaryAdviceSubMenu from 'components/navV2/navPrimarySubMenu/subMenus/NavPrimaryAdviceSubMenu';
import getDataForComponent from 'components/navV2/NavData';

import css from './NavPrimarySubMenuContainer.module.less';

export type NavPrimarySubMenuContainerProps = {
  activeNavType: PrimaryNavIdentifier;
  handleMenuClose: React.MouseEventHandler<HTMLDivElement>;
  userContext: UserContext;
};

const NavPrimarySubMenuContainer = ({
  activeNavType,
  handleMenuClose,
  userContext,
}: NavPrimarySubMenuContainerProps): JSX.Element => {
  let children = null;
  const data = getDataForComponent(activeNavType, userContext);
  if (!data) return <div />;
  switch (activeNavType) {
    case PrimaryNavIdentifier.WEBSITE:
    case PrimaryNavIdentifier.ALBUMS: {
      children = <NavPrimaryLargeModuleSubMenu data={data} activeNavType={activeNavType} />;
      break;
    }
    case PrimaryNavIdentifier.ADVICE: {
      children = <NavPrimaryAdviceSubMenu data={data} activeNavType={activeNavType} />;
      break;
    }
    case PrimaryNavIdentifier.REGISTRY: {
      children = (
        // @ts-expect-error This needs to be refactored to a TypeScript file; the types also look off
        // Changing just this component to TSX caused downstream errors so I'd rather break this into a separate backlog project
        <NavPrimaryRegistrySubmenu activeNavType={activeNavType} data={data} isLoggedIn={false} />
      );
      break;
    }
    default: {
      children = <NavPrimaryGenericSubmenu data={data} activeNavType={activeNavType} />;
      break;
    }
  }

  const mouseLeave: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    handleMenuClose(e);
  };

  return (
    <div className={css.container}>
      <div className={css.inner} onMouseLeave={mouseLeave}>
        {children}
      </div>
    </div>
  );
};

export default NavPrimarySubMenuContainer;
